import {
    ACCESSIONING_LIST,
    BARCODES_LIST_ROUTE,
    BULK_ORDER_LIST_ROUTE,
    BULK_ORDER_VIEW_ROUTE,
    COMING_SOON_ROUTE,
    DASHBOARD,
    FACILITY_ADD_ROUTE,
    FACILITY_DETAILS_LOCATIONS_ROUTE,
    FACILITY_DETAILS_ROUTE,
    FACILITY_LIST_ROUTE,
    LAB_CREATE_ROUTE,
    LAB_DETAILS_ROUTE,
    LAB_LIST_ROUTE,
    LOCATION_ADD_ROUTE,
    LOCATION_DETAILS_ROUTE,
    LOCATION_DETAILS_TEST_ORDER_ROUTE,
    LOCATION_LIST_ROUTE,
    LOGIN_ROUTE,
    LOGOUT_ROUTE,
    NOT_FOUND_ROUTE,
    PATIENT_ADD_ROUTE,
    PATIENT_DETAILS_ROUTE,
    PATIENT_LIST_ROUTE,
    QR_CODE_LIST_ROUTE,
    RESTRICTED_ROUTE,
    RESULT_LIST_ROUTE,
    RESULT_PREVIEW_ROUTE,
    SAMPLES_LIST_ROUTE,
    SEND_OUT_SESSION_DETAILS_ROUTE,
    SEND_OUT_SESSION_LIST_ROUTE,
    STATE_REPORTING_LIST_ROUTE,
    STATE_REPORTING_VIEW_ROUTE,
    SYSTEM_SETTINGS_ROUTE,
    TEST_ORDER_CREATE_ROUTE,
    TEST_ORDER_DETAILS_ROUTE,
    TEST_ORDER_LIST_ROUTE,
    TEST_DETAILS_ROUTE,
    TEST_CREATE_ROUTE,
    TEST_LIST_ROUTE,
    TEST_ROUTE,
    TEST_SAMPLE_ACTIVITY_LOGS_ROUTE,
    ACCESS_LEVEL_LIST_ROUTE,
    ACCESS_LEVEL_ROLE_DETAILS_ROUTE,
    OCR_ROUTE,
    INVENTORY_LIST_ROUTE,
    INVENTORY_ADD_ROUTE,
    INVENTORY_DETAILS_ROUTE,
    ACCESS_LEVEL_ADD_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    SET_NEW_PASSWORD,
    TWO_FACTOR_AUTH,
    CHECK_YOUR_MAIL,
    BIOMARKERS_LIST_ROUTE,
    BIOMARKER_ADD_ROUTE,
    BIOMARKER_DETAILS_ROUTE,
    TEST_PANEL_LIST_ROUTE,
    USER_LIST_ROUTE,
    USER_ADD_ROUTE,
    USER_DETAILS_ROUTE,
    LAB_OS_ROUTE,
    QUALITY_ASSURANCE_ROUTE,
    QUALITY_CONTROL_ROUTE,
    SOP_ROUTE,
    INVENTORY_MANAGEMENT_ROUTE,
    HR_EMPLOYEE_DOCUMENTS_ROUTE,
    INSTRUMENT_ROUTE,
    FORMS_ROUTE,
    LABOS_DEPARTMENTS_ROUTE,
    LABOS_EQUIPMENT_ROUTE,
    LABOS_STORAGE_ROUTE,
    PLATES_ROUTE,
    LABOS_CALCULATIONS_ROUTE,
    LABOS_REPORTS_ROUTE,
    BULK_PATIENT_LIST_ROUTE,
    BULK_PATIENT_VIEW_ROUTE,
    SUPPORT_CENTER_ROUTE,
} from "../../constants/RoutesConfig";
import {LabRoleType} from "../models/lab.model";

const LoginRoute = () => {
    return LOGIN_ROUTE;
}

const NotFoundRoute = () => {
    return NOT_FOUND_ROUTE;
}

const TestRoute = () => {
    return TEST_ROUTE;
}

const ComingSoonRoute = () => {
    return COMING_SOON_ROUTE;
}

const Dashboard = () => {
    return DASHBOARD;
}
const LogoutRoute = () => {
    return LOGOUT_ROUTE;
}
const SamplesListRoute = () => {
    return SAMPLES_LIST_ROUTE;
}
const AccessioningListRoute = () => {
    return ACCESSIONING_LIST;
}
const ResultListRoute = () => {
    return RESULT_LIST_ROUTE;
}
const SendoutSessionListRoute = () => {
    return SEND_OUT_SESSION_LIST_ROUTE;
}
const SendoutSessionDetailsRoute = (sessionID: any) => {
    return SEND_OUT_SESSION_DETAILS_ROUTE + '/' + sessionID;
}
const ResultPreviewRoute = (sessionID: any) => {
    return RESULT_PREVIEW_ROUTE + '/' + sessionID;
}
const TestOrderListRoute = () => {
    return TEST_ORDER_LIST_ROUTE;
}
const TestOrderCreateRoute = () => {
    return TEST_ORDER_CREATE_ROUTE;
}
const TestOrderDetailsRoute = (orderID: any) => {
    return TEST_ORDER_DETAILS_ROUTE + '/' + orderID;
}
const PatientAddRoute = () => {
    return PATIENT_ADD_ROUTE;
}
const TestListRoute = () => {
    return TEST_LIST_ROUTE;
}
const TestCreateRoute = () => {
    return TEST_CREATE_ROUTE;
}
const TestDetailsRoute = (testID: any) => {
    return TEST_DETAILS_ROUTE + '/' + testID;
}
const StateReportingViewRoute = (reportId:any) => {
    return STATE_REPORTING_VIEW_ROUTE + '/' + reportId;
}
const FacilityListRoute = () => {
    return FACILITY_LIST_ROUTE;
}
const FacilityAddRoute = () => {
    return FACILITY_ADD_ROUTE;
}
const FacilityDetailsLocationRoute = (facilityId: any) => {
    return FACILITY_DETAILS_LOCATIONS_ROUTE + '/' + facilityId;
}
const LocationDetailsTestOrderRoute = (locationId: any) => {
    return LOCATION_DETAILS_TEST_ORDER_ROUTE + '/' + locationId;
}
const FacilityDetailsRoute = (facilityId: any) => {
    return FACILITY_DETAILS_ROUTE + '/' + facilityId;
}
const LabListRoute = () => {
    return LAB_LIST_ROUTE;
}
const LabCreateRoute = (labRole:LabRoleType) => {
    return LAB_CREATE_ROUTE+`/${labRole}`;
}
const LabDetailsRoute = (labID: any,labRole:LabRoleType) => {
    return LAB_DETAILS_ROUTE + `/${labID}/${labRole}`;
}
const PatientListRoute = () => {
    return PATIENT_LIST_ROUTE;
}
const BulkPatientListRoute=()=>{
    return BULK_PATIENT_LIST_ROUTE;
}
const BulkPatientViewRoute = (bulkPatientID:string) => {
    return BULK_PATIENT_VIEW_ROUTE+ '/' + bulkPatientID;
}
const QrCodeListRoute = () => {
    return QR_CODE_LIST_ROUTE;
}
const PatientDetailsRoute = (patientID: any) => {
    return PATIENT_DETAILS_ROUTE + '/' + patientID;
}
const LocationListRoute = () => {
    return LOCATION_LIST_ROUTE;
}
const LocationAddRoute = () => {
    return LOCATION_ADD_ROUTE;
}

const BiomarkerAddRoute = () => {
    return BIOMARKER_ADD_ROUTE;
}
const LocationDetailsRoute = (locationID: any) => {
    return LOCATION_DETAILS_ROUTE + '/' + locationID;
}
const BulkOrderListRoute = () => {
    return BULK_ORDER_LIST_ROUTE;
}
const BulkOrderViewRoute = (bulkOrderID: any) => {
    return BULK_ORDER_VIEW_ROUTE + '/' + bulkOrderID;
}
const RestrictedRoute = () => {
    return RESTRICTED_ROUTE;
}
const StateReportingListRoute = () => {
    return STATE_REPORTING_LIST_ROUTE;
}
const BarcodesListRoute = () =>{
    return BARCODES_LIST_ROUTE;
}
const SystemSettingsRoute = () =>{
    return SYSTEM_SETTINGS_ROUTE;
}

const UserListRoute = () =>{
    return USER_LIST_ROUTE;
}
const AccessLevelListRoute = () =>{
    return ACCESS_LEVEL_LIST_ROUTE;
}
const InventoryListRoute = () =>{
    return INVENTORY_LIST_ROUTE;
}
const OCRBillingListRoute = () =>{
    return OCR_ROUTE;
}
const SupportCenterRoute=()=>{
    return SUPPORT_CENTER_ROUTE;
}

const TestSampleActivityLogsRoute = (testOrderId: any,testSampleId: any,returnModule:any = "testOrder") => {
    return TEST_SAMPLE_ACTIVITY_LOGS_ROUTE + '/' + testOrderId + '/' +testSampleId +'?returnModule=' + returnModule;
}

const sampleListRouteWithQueryParams = (queryParams:any) => {
    return SAMPLES_LIST_ROUTE + '?sampleStatuses=' + queryParams;
}

const DashboardRoute = () => {
    return DASHBOARD;
}
const AccessLevelRoleDetailsRoute = (roleId: any,role:any,updatedAt:any) => {
    return ACCESS_LEVEL_ROLE_DETAILS_ROUTE + '/' + roleId + '?role=' + role + '&updatedAt=' + updatedAt;
}
const InventoryAddRoute = () => {
    return INVENTORY_ADD_ROUTE;
}
const InventoryDetailsRoute = (inventoryId: any) => {
    return INVENTORY_DETAILS_ROUTE + '/' + inventoryId;
}

const AccessRoleAddRoute = () => {
    return ACCESS_LEVEL_ADD_ROUTE;
}

const ForgotPasswordRoute = () => {
    return FORGOT_PASSWORD_ROUTE;
}
const SetNewPasswordRoute = () => {
    return SET_NEW_PASSWORD;
}

const TwoFactorAuthRoute = () => {
    return TWO_FACTOR_AUTH;
}

const CheckYourEmailRoute = (emailId:string) => {
    return CHECK_YOUR_MAIL + "/" + emailId;
}

const BiomarkerListRoute = () => {
    return BIOMARKERS_LIST_ROUTE;
}

const BiomarkerDetailsRoute = (biomarkerId:any) => {
    return BIOMARKER_DETAILS_ROUTE + "/" + biomarkerId;
}

const TestPanelListRoute = () => {
    return TEST_PANEL_LIST_ROUTE
}

const AddUserRoute = () => {
    return USER_ADD_ROUTE;
}

const UserDetailsRoute = (userId:any) => {
    return USER_DETAILS_ROUTE + "/" + userId;
}

const LabOsRoute=()=>{
    return LAB_OS_ROUTE
}

const LabDepartmentsRoute=()=>{
    return LABOS_DEPARTMENTS_ROUTE;
}

const LabEquipmentRoute=()=>{
    return LABOS_EQUIPMENT_ROUTE;
}
const LabOsSampleProcessingRoute=()=>{
    return LAB_OS_ROUTE + "/sample-processing"
}
const QualityControlRoute = () => {
    return QUALITY_CONTROL_ROUTE;
}

const QualityAssuranceRoute = () => {
    return QUALITY_ASSURANCE_ROUTE;
}
const SopRoute = () => {
    return SOP_ROUTE;
}
const InventoryManagementRoute = () => {
    return INVENTORY_MANAGEMENT_ROUTE;
}

const InstrumentRoute = () => {
    return INSTRUMENT_ROUTE;
}
const HrDocumentsRoute = () => {
    return HR_EMPLOYEE_DOCUMENTS_ROUTE;
}

const formsRoute = () => {
    return FORMS_ROUTE;
}

const LabStorageRoute = () => {
    return LABOS_STORAGE_ROUTE;
}

const LabPlatesRoute = () => {
    return PLATES_ROUTE;
}

const LabCalculationsRoute = () => {
    return LABOS_CALCULATIONS_ROUTE;
}

const LabReportsRoute = () => {
    return LABOS_REPORTS_ROUTE;
}

const RouteConfigService = {
    LoginRoute,
    NotFoundRoute,
    RestrictedRoute,
    SystemSettingsRoute,
    TestRoute,
    ComingSoonRoute,
    LogoutRoute,
    SamplesListRoute,
    AccessioningListRoute,
    ResultListRoute,
    TestOrderListRoute,
    TestOrderCreateRoute,
    TestOrderDetailsRoute,
    TestListRoute,
    PatientListRoute,
    BulkPatientListRoute,
    BulkPatientViewRoute,
    LocationListRoute,
    LocationAddRoute,
    FacilityListRoute,
    LabListRoute,
    LabCreateRoute,
    ResultPreviewRoute,
    PatientAddRoute,
    Dashboard,
    PatientDetailsRoute,
    SendoutSessionListRoute,
    SendoutSessionDetailsRoute,
    QrCodeListRoute,
    TestCreateRoute,
    TestDetailsRoute,
    LabDetailsRoute,
    FacilityAddRoute,
    FacilityDetailsLocationRoute,
    FacilityDetailsRoute,
    LocationDetailsTestOrderRoute,
    LocationDetailsRoute,
    BulkOrderListRoute,
    BulkOrderViewRoute,
    StateReportingListRoute,
    StateReportingViewRoute,
    BarcodesListRoute,
    TestSampleActivityLogsRoute,
    sampleListRouteWithQueryParams,
    DashboardRoute,
    AccessLevelListRoute,
    AccessLevelRoleDetailsRoute,
    OCRBillingListRoute,
    SupportCenterRoute,
    InventoryListRoute,
    InventoryAddRoute,
    InventoryDetailsRoute,
    AccessRoleAddRoute,
    ForgotPasswordRoute,
    SetNewPasswordRoute,
    TwoFactorAuthRoute,
    CheckYourEmailRoute,
    BiomarkerListRoute,
    BiomarkerAddRoute,
    BiomarkerDetailsRoute,
    TestPanelListRoute,
    UserListRoute,
    AddUserRoute,
    UserDetailsRoute,
    LabOsRoute,
    QualityControlRoute,
    QualityAssuranceRoute,
    HrDocumentsRoute,
    SopRoute,
    InventoryManagementRoute,
    InstrumentRoute,
    LabOsSampleProcessingRoute,
    formsRoute,
    LabDepartmentsRoute,
    LabEquipmentRoute,
    LabStorageRoute,
    LabPlatesRoute,
    LabCalculationsRoute,
    LabReportsRoute
}

export default RouteConfigService;
